<!--  -->
<template>
  <div class="Info3">
    <!-- 内容盒子 -->
    <div class="back" @click="$router.go(-1)">
      <img src="../assets/home/back.png" alt="" />
    </div>
    <div class="title">清象牙镂雕花卉纹<br />开光亭塔山水帽章扇</div>
    <div class="foll">
      <img src="../assets/home/foll1.png" alt="" @click="lookTxt = true" />
      <img src="../assets/home/foll2.png" alt="" @click="videoShow = true" />
    </div>
    <!-- 点击文物介绍出现的盒子 -->
    <div class="txtBox" v-show="lookTxt">
      <div class="txt">
        <p>
          这把帽章扇按形制和尺幅来看，属乾隆末期（约18世纪90年代）流行的款式。它由六十四档象牙扇骨构成，每档扇尾呈锯齿尖叶形，两支大骨剔地高浮雕椭圆开光花卉、山水风景；扇面轻薄通透如蝉翼，采用单面镂通拉丝薄意浅浮雕的技法，由同心圆向外做九层装饰。
        </p>
        <p>
          顶部饰折枝花卉一周；中部主体以椭圆形亭塔山水开光为中心，两侧对称雕小圆形开光，内饰花卉纹，辅以几何花卉纹点缀其间；每层纹饰之间以圆珠带状纹相隔，扇背光素。扇面通体牙丝铺地，细如发丝；纹饰疏密有致，连绵铺展整个扇面，繁而不乱。其玲珑剔透的质感、鬼斧神工的技艺，完美体现了当时外销扇象牙雕刻工艺的高超水准。
        </p>
        <p>
          清朝乾嘉之际出现了一款完全由扇骨构成，以丝带连缀，且扇面可360度展开后呈团扇造型的扇子，西方称之为“帽章扇”（Cockade
          fan）。“帽章”（Cockade）指的是一种装饰于帽缘上的圆形徽章，通常花色亦成同心圆形状。它在中国出现的时间可谓“昙花一现”，主要集中在18世纪末至19世纪初，是至为名贵的外销扇品种，传世极少，多为欧洲皇室贵族旧藏。因此扇工艺复杂，价格昂贵，后逐渐退出了生产。
        </p>
      </div>
      <div class="close">
        <img src="../assets/home/close.png" alt="" @click="lookTxt = false" />
      </div>
    </div>
    <div class="box3Video" v-if="videoShow" @click="videoChange = !videoChange">
      <div class="back" @click="videoShow = false">
        <img src="../assets/home/back.png" alt="" />
      </div>
      <div class="videoMain">
        <img src="data/box3/box3_2.gif" v-show="videoChange" alt="" />
        <img src="data/box3/box3_1.gif" v-show="!videoChange" alt="" />
        <!-- <video
          autoplay
          muted
          loop
          src="data/box3/box3_2.mp4"
          v-show="videoChange"
        ></video>
        <video
          autoplay
          muted
          loop
          src="data/box3/box3_1.mp4"
          v-show="!videoChange"
        ></video> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Info3",
  components: {},
  data() {
    //这里存放数据
    return {
      lookTxt: false,
      videoShow: false,
      videoChange: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {
    this.lookTxt = false;
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.Info3 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #07405f;
  .back {
    z-index: 10;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 23px;
    pointer-events: auto;
    touch-action: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    z-index: 10;
    position: absolute;
    width: 100%;
    top: 80px;
    left: 0;
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    color: #fff;
  }
  .foll {
    z-index: 10;
    position: absolute;
    left: 0;
    bottom: 50px;
    width: 100%;
    height: 40px;
    text-align: center;
    img {
      margin: 0 10px;
      width: 60px;
      height: 45px;
    }
  }
  .txtBox {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 150px);
    z-index: 11;
    padding: 0 30px;
    color: #00ffff;
    background-color: #103952;
    .txt::-webkit-scrollbar {
      width: 2px;
      height: 0px;
    }
    .txt::-webkit-scrollbar-track-piece {
      background-color: transparent;
    }
    .txt::-webkit-scrollbar-thumb {
      background: #00ffff;
    }
    .txt {
      width: 100%;
      height: calc(100% - 80px);
      overflow-y: auto;
      p {
        text-indent: 2rem;
        margin-bottom: 10px;
        line-height: 26px;
      }
    }
    .close {
      margin-top: 20px;
      width: 100%;
      height: 60px;
      text-align: center;
      img {
        width: 38px;
        height: 38px;
      }
    }
  }
  .box3Video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    background-image: linear-gradient(to bottom, #033f5f, #00336d);
  }
  .videoMain {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    img {
      width: 100%;
    }
  }
}
</style>